import { Box, Grid, Typography } from "@mui/material";
import CustomButton from "../../../components/custom-button/CustomButton";
import { PlusCircle } from "@phosphor-icons/react";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setOpenModalAddStandard } from "../slices/modalAddStandardSlice";
import CustomListArticlesSelected from "./CustomListArticlesSelected";
import { setOpenSpecialAddModal } from "../slices/specialAddModalSlice";
import { useTranslation } from "react-i18next";

const PreOrderArticles = () => {
  const dispatch = useAppDispatch();
const {t} = useTranslation();
  const handleOpenModalStandard = () => {
    dispatch(setOpenModalAddStandard(true));
  };
const {direction} = useAppSelector((state) => state.languageSlice)
  const handleOpenSpecialAddModal = () => {
    dispatch(setOpenSpecialAddModal(true));
  };
  return (
    <>
      <Grid container mt={2} sx={{ flexDirection: direction === 'ltr' ? 'row' : 'row-reverse' }} >
        <Grid
          item
          xs={12}
          sm={12}
          md
          sx={{
            display: "flex",
            flexDirection: direction === 'ltr' ? 'row' : 'row-reverse' ,
            justifyContent: "space-between",

          }}
        >
          <Typography variant="h6">
            {t("newPreOrder.titles.articles")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Box
            sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
          >
            <CustomButton
              onClick={handleOpenSpecialAddModal}
              truncate
              startIcon={<PlusCircle size={24} />}
              buttonColor="buttonStyleSecondary"
            >
              {t("newPreOrder.buttons.specialAdd")}
            </CustomButton>
            <Box m={1}></Box>
            <CustomButton
              onClick={handleOpenModalStandard}
              truncate
              startIcon={<PlusCircle size={24} />}
              buttonColor="buttonStyleSecondary"
            >
              {t("newPreOrder.buttons.standardAdd")}
            </CustomButton>
          </Box>
        </Grid>
      </Grid>
      <Box mt={2}>
        <CustomListArticlesSelected />
      </Box>
    </>
  );
};

export default PreOrderArticles;
